import {ChangeDetectorRef, Component, Inject} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AdminService} from '../../services/admin.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import Swal from "sweetalert2";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-edit-status',
  templateUrl: './edit-status.component.html',
  styleUrls: ['./edit-status.component.scss']
})
export class EditStatusComponent {
  volunteerStatusForm: FormGroup;
  isEditMode: boolean;
  statuses = ['PENDING', 'ACCEPTED', 'REJECTED'];
  loading = false;

  constructor(
    private fb: FormBuilder,
    private cdRef: ChangeDetectorRef,
    private adminService: AdminService,
    public dialogRef: MatDialogRef<EditStatusComponent>,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: { volunteers: any }
  ) {
    this.isEditMode = !!data.volunteers?.id;
    this.volunteerStatusForm = this.fb.group({
      fullName: [data.volunteers?.fullName || '', Validators.required],
      status: [data.volunteers?.status || 'PENDING', Validators.required],
    });
  }

  updateStatus() {
    if (this.volunteerStatusForm.valid) {
      const status = this.volunteerStatusForm.get('status')?.value;

      this.translate.get([
        'Are you sure?',
        'Do you want to accept this volunteer?',
        'Do you want to reject this volunteer?',
        'Yes',
        'No',
        'Status Updated',
        'The volunteer status has been successfully updated!',
        'Error',
        'There was an issue updating the status. Please try again later.',
        'OK'
      ]).subscribe(translations => {
        Swal.fire({
          title: translations['Are you sure?'],
          text: status === 'ACCEPTED' ? translations['Do you want to accept this volunteer?'] : translations['Do you want to reject this volunteer?'],
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: translations['Yes'],
          cancelButtonText: translations['No'],
        }).then((result) => {
          if (result.isConfirmed) {
            this.loading = true;
            this.adminService.updateVolunteerStatus(this.data.volunteers.id, status).subscribe({
              next: () => {
                this.loading = false;
                Swal.fire({
                  icon: 'success',
                  title: translations['Status Updated'],
                  text: translations['The volunteer status has been successfully updated!'],
                  confirmButtonText: translations['OK'],
                }).then(() => {
                  this.dialogRef.close(true);
                });
              },
              error: () => {
                Swal.fire({
                  title: translations['Error'],
                  text: translations['There was an issue updating the status. Please try again later.'],
                  icon: 'error',
                  confirmButtonText: translations['OK'],
                }).then(() => {
                  this.loading = false;
                  this.cdRef.detectChanges();
                });
              },
            });
          }
        });
      });
    }
  }

  cancel() {
    this.dialogRef.close();
  }
}
